import React, { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiSearch, FiBell, FiCalendar, FiMenu, FiCpu, FiExternalLink } = FiIcons;

function Header({ onMenuClick }) {
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState('');
  
  const getPageTitle = () => {
    switch (location.pathname) {
      case '/':
        return 'Sales Dashboard';
      case '/customers':
        return 'Customer Management';
      case '/leads':
        return 'Lead Management';
      case '/sales':
        return 'Sales Tracking';
      case '/inventory':
        return 'Vehicle Inventory';
      case '/analytics':
        return 'Sales Analytics';
      case '/ai-tools':
        return 'AI Tools';
      default:
        return 'AutoCRM';
    }
  };

  const getPageDescription = () => {
    switch (location.pathname) {
      case '/':
        return 'Overview of your sales performance and activities';
      case '/customers':
        return 'Manage your customer relationships and service history';
      case '/leads':
        return 'Track and convert prospects into customers';
      case '/sales':
        return 'Monitor sales transactions and revenue';
      case '/inventory':
        return 'Manage vehicle inventory and availability';
      case '/analytics':
        return 'Insights into sales trends and performance metrics';
      case '/ai-tools':
        return 'AI-powered tools to enhance your sales process';
      default:
        return 'Automotive Customer Relationship Management';
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    console.log('Searching for:', searchTerm);
    // Implement search functionality
  };

  return (
    <header className="bg-white border-b border-gray-200 px-3 sm:px-4 lg:px-6 py-3 lg:py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          {/* Mobile menu button */}
          <button
            onClick={onMenuClick}
            className="p-2 text-gray-400 hover:text-gray-500 hover:bg-gray-100 rounded-lg transition-colors lg:hidden"
          >
            <SafeIcon icon={FiMenu} className="h-5 w-5" />
          </button>
          <div>
            <h2 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-900">{getPageTitle()}</h2>
            <div className="flex items-center">
              <p className="text-xs sm:text-sm text-gray-500 mt-1 hidden sm:block">{getPageDescription()}</p>
              <a
                href="https://shawnryder.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hidden sm:flex items-center text-xs text-primary-600 hover:text-primary-700 ml-2"
              >
                <span>by Shawn Ryder Digital</span>
                <SafeIcon icon={FiExternalLink} className="w-3 h-3 ml-1" />
              </a>
            </div>
          </div>
        </div>
        <div className="flex items-center space-x-2 sm:space-x-4">
          {/* Search - Hidden on mobile, shown on larger screens */}
          <div className="relative hidden md:block">
            <form onSubmit={handleSearch}>
              <SafeIcon icon={FiSearch} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search customers, leads, vehicles..."
                className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent w-64 lg:w-80"
              />
            </form>
          </div>
          
          {/* Mobile search button */}
          <button className="p-2 text-gray-400 hover:text-gray-500 hover:bg-gray-100 rounded-lg transition-colors md:hidden">
            <SafeIcon icon={FiSearch} className="h-5 w-5" />
          </button>
          
          {/* AI Tools shortcut */}
          <Link to="/ai-tools">
            <button className="p-2 text-gray-400 hover:text-primary-500 hover:bg-primary-50 rounded-lg transition-colors">
              <SafeIcon icon={FiCpu} className="h-5 w-5" />
            </button>
          </Link>
          
          <button className="p-2 text-gray-400 hover:text-gray-500 hover:bg-gray-100 rounded-lg transition-colors">
            <SafeIcon icon={FiCalendar} className="h-5 w-5" />
          </button>
          
          <button className="relative p-2 text-gray-400 hover:text-gray-500 hover:bg-gray-100 rounded-lg transition-colors">
            <SafeIcon icon={FiBell} className="h-5 w-5" />
            <span className="absolute -top-1 -right-1 h-3 w-3 bg-red-500 rounded-full"></span>
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;